import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import immutableTransform from '../immutableTransform'
import createSagaMiddleware from 'redux-saga'

import rootSaga from '../sagas'
import auth from '../../modules/Auth/reducer'
import promotions from '../../modules/Promotions/reducer'
import filters from '../../modules/Filters/reducer'
import common from '../../modules/Common/reducer'
import { storesReducer } from '../../modules/stores/reducer'
import { ordersReducer } from '../../modules/orders/reducer'
import { productReducer } from '../../modules/Products/reducer'
import pushNotifications from '../../modules/PushNotifications/reducer'
import { sagaRedirectAuthInfo } from '../../modules/Auth/actions'

// Saga middleware
const sagaMiddleware = createSagaMiddleware()

// Redux Persist Configs
const persistConfig = {
    key: 'root',
    storage,
    transforms: [immutableTransform],
    whitelist: [],
}

/* const promoPersist = {
    key: 'promotions',
    storage,
    whitelist: ['size', 'pageNo', 'order', 'orderBy', 'count'],
} */

const authPersist = {
    key: 'auth',
    storage,
    blacklist: ['is_logout'],
}

/* const notificationPersist = {
    key: 'notifications',
    storage,
    whitelist: ['size', 'pageNo', 'order', 'orderBy', 'count'],
} */

const rootReducer = combineReducers({
    filters,
    auth: persistReducer(authPersist, auth),
    promotions,
    common,
    pushNotifications,
    stores: storesReducer,
    products: productReducer,
    orders: ordersReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

// Create the store with configureStore
const store = configureStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: false, // Required due to redux-persist
        }).concat(sagaMiddleware),
    devTools: process.env.REACT_APP_ENV !== 'production',
})

const persistor = persistStore(store, null, () => {
    store.dispatch(sagaRedirectAuthInfo())
})

sagaMiddleware.run(rootSaga)

export { store, persistor, rootReducer }
